import {
  MessagePreview,
  NoticePageCTANotification,
} from "components/noticepage_components/utils"
import { graphql, useStaticQuery } from "gatsby"

import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"

export const NoticeMessages = ({
  failed_request,
  messages,
  set_message_update_info_modal_open,
  set_message_cta_modal_open,
  set_message_modal_state,
  info_notification_open,
  set_info_notification_open,
  has_parts = false,
  RefIDStringBI,
}) => {
  const open_cta_modal = () => {
    set_message_cta_modal_open("is-active")
  }

  const { mailManImage } = useStaticQuery(graphql`
    {
      mailManImage: file(name: { eq: "mail-man" }) {
        childImageSharp {
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 430
            formats: [AVIF, AUTO]
          )
        }
      }
    }
  `)
  return (
    <React.Fragment>
      {failed_request ? (
        <div className="is-flex is-flex-direction-column">
          <p className="title is-5 mt-6 pt-6 has-text-centered has-text-mitternachtsblau">
            Tut uns Leid, wir konnten die Mitteilungen nicht finden.
          </p>
          <p className="mb-6 has-text-centered has-text-mitternachtsblau">
            Es ist ein Fehler aufgetreten, das tut uns leid.
          </p>
        </div>
      ) : (
        <React.Fragment>
          {!!messages ? (
            <React.Fragment>
              {info_notification_open ? (
                <NoticePageCTANotification
                  {...{
                    set_message_update_info_modal_open,
                    current_part: "messages",
                    set_info_notification_open,
                    RefIDStringBI,
                  }}
                />
              ) : null}

              <div className="has-text-right px-3 mt-5">
                <button
                  className="button is-sonnengelb has-text-weight-bold"
                  onClick={open_cta_modal}
                >
                  Neue Mitteilung schreiben
                </button>
              </div>
              <div className="columns mt-4">
                <div className="column is-3">
                  <hr className="is-mitternachtsblau-30 mt-0 is-slim" />
                  <p className="title is-5 has-text-mitternachtsblau mb-0">
                    Empfangene
                  </p>
                  <hr className="is-mitternachtsblau-30 is-slim" />
                  <div
                    className="mb-0 is-clickable"
                    title="Dies ist ein Premium-Feature"
                    onClick={open_cta_modal}
                    role="button"
                    tabIndex="-1"
                    onKeyDown={() => {}}
                    aria-label="Open CTA Modal"
                  >
                    <span className="title is-5 has-text-mitternachtsblau-30 mr-3 mb-0">
                      Gesendet
                    </span>
                  </div>
                  <hr className="is-mitternachtsblau-30 is-slim" />
                  <div
                    className="mb-0 is-clickable"
                    title="Dies ist ein Premium-Feature"
                    onClick={open_cta_modal}
                    role="button"
                    tabIndex="-2"
                    onKeyDown={() => {}}
                    aria-label="Open CTA Modal"
                  >
                    <span className="title is-5 has-text-mitternachtsblau-30 mr-3 mb-0">
                      Entwürfe
                    </span>
                  </div>
                  <hr className="is-mitternachtsblau-30 is-slim" />
                </div>
                <div className="column is-9">
                  <div className="box p-0">
                    {!!messages?.[0] ? (
                      <React.Fragment>
                        {messages?.map(
                          (
                            { subject, body, releaseDate, attachments },
                            index
                          ) => {
                            return (
                              <MessagePreview
                                key={"message-" + index}
                                {...{
                                  attachments,
                                  body,
                                  index,
                                  num_messages: messages?.length,
                                  releaseDate,
                                  set_message_modal_state,
                                  subject,
                                }}
                              />
                            )
                          }
                        )}
                      </React.Fragment>
                    ) : (
                      <div className="is-flex p-6">
                        <div className="m-auto">
                          <GatsbyImage
                            image={mailManImage.childImageSharp.gatsbyImageData}
                            alt="Keine Mitteilungen gefunden"
                            title="Keine Mitteilungen gefunden"
                          />
                          <p className="has-text-centered has-text-mitternachtsblau py-5">
                            Zu {has_parts ? "diesem Los" : "dieser Vergabe"}{" "}
                            gibt es noch keine Nachrichten.
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className="is-flex is-flex-direction-column">
              <p className="title is-5 my-6 has-text-centered has-text-mitternachtsblau">
                Mitteilungen werden geladen, einen Moment bitte...
              </p>
              <div className="spinner m-auto"></div>
            </div>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
